module.exports = __webpack_public_path__ + "img/1565887667.31ae862c.jpg";